export default __webpack_public_path__ + "static/node@2x-2df081edb4946a710d5249a1ce670a7c.png";